import React from 'react';
import Types from 'prop-types';
import classNames from 'classnames';
var MenuToggle = function MenuToggle(_ref) {
  var isMenuOpen = _ref.isMenuOpen,
    onToggle = _ref.onToggle,
    children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("button", {
    onClick: onToggle,
    className: classNames('tw-public-nav__menu-toggle', className, {
      'is-collapsed': !isMenuOpen,
      'is-open': isMenuOpen
    }),
    "aria-controls": "navbar",
    "aria-expanded": isMenuOpen,
    type: "button",
    "aria-label": "Toggle navigation"
  }, children);
};
MenuToggle.defaultProps = {
  className: '',
  children: null
};
export default MenuToggle;